/*LIBRARY*/
import React from "react";
import { useSelector } from "react-redux";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const FOLDER_CHILD = ({
  folder_id_selected_move,
  folder_list_child,
  folder_project_list_all,
  folder_id_selected,
  on_click_folder,
}) => {
  //local storage
  const auth = useSelector((state) => state.auth);
  const language = localStorage?.language || auth.language;

  //local state

  //global props

  //content
  return (
    <main>
      {folder_list_child.map((item) => {
        const nested_folder_list_child = folder_project_list_all.filter(
          (child) => child?.folder_parent_id === item?._id,
        );
        return (
          <div
            key={item?._id}
            className="margin_bottom"
            style={{ marginLeft: "50px" }}
          >
            <div onClick={() => on_click_folder(item?._id)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={16.581}
                height={24.994}
                viewBox="0 0 4.387 6.613"
                className="inline_bottom margin_right"
              >
                <path
                  d="M4.189 4.189H1.373c-.65 0-1.175-.524-1.175-1.175V.198"
                  style={{
                    fill: "none",
                    paintOrder: "stroke markers fill",
                    strokeDashoffset: 11.411,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 0.39688,
                    stroke:
                      folder_id_selected_move === item?._id
                        ? "#000"
                        : "#a5b3b6",
                  }}
                />
                <path
                  d="M2.986 2.986 4.19 4.19 2.986 5.39"
                  style={{
                    fill: "none",
                    paintOrder: "stroke markers fill",
                    strokeDashoffset: 11.411,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 0.39688,
                    stroke:
                      folder_id_selected_move === item?._id
                        ? "#000"
                        : "#a5b3b6",
                  }}
                />
              </svg>
              <span
                className={`cursor_pointer inline_bottom button ${
                  folder_id_selected_move === item?._id
                    ? "background_green"
                    : "button_white"
                }`}
              >
                {item?.name}
              </span>
            </div>

            {folder_id_selected === item?._id && (
              <p className="badge">{dict?.["Current"]?.[language]}</p>
            )}

            {nested_folder_list_child?.length > 0 && (
              <FOLDER_CHILD
                folder_list_child={nested_folder_list_child}
                folder_project_list_all={folder_project_list_all}
                on_click_folder={on_click_folder}
                folder_id_selected_move={folder_id_selected_move}
                folder_id_selected={folder_id_selected}
              />
            )}
          </div>
        );
      })}
    </main>
  );
};

export default FOLDER_CHILD;
